<form [formGroup]="form">
  <div class="d-flex flex-column mb-3">
    <div
      class="d-flex justify-content-start align-items-center fw-medium bg-primary bg-opacity-10 mt-2 fs-5 p-2 pb-1 rounded-2">
      <div class="col-1"><i class="las la-tachometer-alt fs-1"></i></div>
      <div class="col-10">
        <span>{{ selectedRow.name }} • {{ selectedRow.connectivityStatus }}</span>
        <p>{{ selectedRow.category }}</p>
      </div>
    </div>
  </div>

  <div class="d-flex gap-2 mb-3">
    <div class="flex-fill w-100">
      <p-calendar
        [dateFormat]="'dd-mm-yy'"
        [showIcon]="true"
        formControlName="readingDate"
        inputStyleClass="form-control"
        inputValidator
      />
    </div>
    <div class="input-group flex-fill">
      <input
        [disabled]="selectedRow.connectivityStatus.toLowerCase() === 'Online'"
        [ngClass]="{'text-muted': selectedRow.connectivityStatus.toLowerCase() === 'Online'}"
        [placeholder]="'ENERGY.ENTER_VALUE' | translate"
        [readonly]="selectedRow?.connectivityStatus.toLowerCase() === 'Online'"
        aria-describedby="text1"
        class="form-control"
        formControlName="readingValue"
        type="text"
      />
      <span class="input-group-text" id="text1">{{ selectedRow?.unitType?.type }}</span>
    </div>
    <button
      (click)="addReading()"
      [disabled]="selectedRow.connectivityStatus.toLowerCase() === 'Online'"
      [ngClass]="{'text-muted': selectedRow.connectivityStatus.toLowerCase() === 'Online'}"
      class="flex-fill btn btn-outline-primary"
      type="button">
      <i class="las la-plus fs-5 cursor-pointer"></i>
    </button>

    <button
      (click)="getMeterReading()"
      [disabled]="selectedRow.connectivityStatus.toLowerCase() === 'Offline'"
      [ngClass]="{'text-muted': selectedRow.connectivityStatus.toLowerCase() === 'Offline'}"
      class="flex-fill btn btn-outline-primary"
      type="button">
      <i class="las la-search-plus fs-5 cursor-pointer"></i>
    </button>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger my-2">{{ errorMessage }}</div>

  @if (isPending()) {
    <div class="position-relative" [style.height.px]="150">
      <spinner></spinner>
    </div>
  } @else {
    <table>
      <tr>
        <th style="width: 5%">№</th>
        <th style="width: 45%">{{ 'RESIDENTS.DATE'| translate }}</th>
        <th style="width: 40%">{{ 'PROVIDERS.VALUE'| translate }}</th>
        <th style="width: 10%"></th>
      </tr>
      @if (readings.length > 0) {
        @for (reading of readings;track $index) {
          <tr>
            <td>{{ $index + 1 }}.</td>
            <td>{{ reading.readingDate | date:'dd/MM/yyyy' }}</td>
            <td>{{ reading.readingValue }}</td>
            <td>
                <span class="cursor-pointer" (click)="removeReading($index)">
                  <i class="ri-delete-bin-line fs-24 text-danger"></i>
                </span>
            </td>
          </tr>
        }
      } @else {
        <tr>
          <td colspan="4">{{ "ENERGY.NO_READING" | translate }}</td>
        </tr>
      }
    </table>
  }

  <div class="mt-4 d-flex gap-2 justify-content-end">
    <button (click)="cancel()" class="btn btn-soft-primary" type="button">{{ 'CANCEL' | translate }}</button>
    <button (click)="saveReadings()" class="btn btn-primary">{{ 'SAVE' | translate }}</button>
  </div>
</form>
